<template>
    <div class="how-it-works">
        <div class="content">
            <h2>Como funciona a <strong>Engelink Crédito</strong></h2>
            <p>O processo é bem simples, em quatro passos você decide a frequência e os recebíveis que deseja antecipar.</p>
            <div class="steps">
                <div v-for="(item, index) in steps" :key="index">
                    <i :class="item.class" class="icon"></i>
                    <h3>{{ item.title }}</h3>
                    <p>{{ item.text }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'HowItWorks',
    data() {
        return {
            steps: [
                {
                    class: 'fas fa-file-upload',
                    title: 'Cadastre-se',
                    text:
                        'Faça seu cadastro sem burocracia, não é preciso enviar nenhum documento.'
                },
                {
                    class: 'fas fa-thumbs-up',
                    title: 'Pré-aprovação',
                    text:
                        'Analisamos e enviamos uma proposta de crédito para antecipação dos recebíveis.'
                },
                {
                    class: 'fas fa-file-signature',
                    title: 'Assinatura digital',
                    text:
                        'Envie os documentos e receba seu contrato online para assinar digitalmente.'
                },
                {
                    class: 'fas fa-hand-holding-usd',
                    title: 'Antecipação',
                    text:
                        'Com o contrato assinado, já está tudo pronto para anteciparmos seus boletos.'
                }
            ]
        };
    }
};
</script>

<style lang="scss" scoped>
.how-it-works {
    background: #EDEDED;
    text-align: center;
    padding: 72px 16px;
    @media screen and (max-width: 800px) {
        padding: 36px 16px;
    }
    .content {
        max-width: 1120px;
        width: 100%;
        margin: 0 auto;
        h2 {
            color: #0e3d74;
            font-family: 'Open Sans', sans-serif;
            font-size: 30px;
            line-height: 40px;
            margin: 0;
            font-weight: 500;
            margin-bottom: 15px;
            strong {
                font-weight: bold;
            }
        }
        p {
            font-size: 18px;
        }
        .steps {
            display: grid;
            grid-template-columns: repeat(4, 1fr);
            gap: 30px;
            padding-top: 36px;
            @media screen and (max-width: 800px) {
                grid-template-columns: repeat(2, 1fr);      
            }
            @media screen and (max-width: 580px) {
                grid-template-columns: repeat(1, 1fr);      
            }
            .icon {
                color: #007bff;
                font-size: 50px;
            }
            h3 {
                color: #000;
                font-family: 'Open Sans', sans-serif;
                font-size: 26px;
                line-height: 30px;
                font-weight: 700;
            }
            p {
                font-size: 16px;
            }
        }
    }
}
</style>
